export default {
	game: {
		maintenance: 'メンテナンス中',
		maintenance_tip: '現在利用できません',
		no_more_data: 'これ以上のデータはありません',
		search_game_name: 'ゲーム名を検索...',
		selected: '選択済み',
		type: '種類',
		all_types: 'すべての種類',
		secondary: 'サブ',
		secondary_category: 'サブカテゴリ',
		no_related_games: '関連ゲームが見つかりません',
		reset_all: 'すべてリセット',
		end_of_list: 'リストの終わり',
		game_details: 'ゲーム詳細',
		play: 'プレイ',
		bonus_cannot_wagered: 'ボーナスは賭けに使用できません',
		entering_game: 'ゲームに入っています。お待ちください...',
		entering_game_short: 'ゲームに入っています...',
		game_types: 'ゲーム種類',
		game_providers: 'ゲームプロバイダー',
		sign_up: '登録',
		search: '検索',
		all_providers: 'すべてのプロバイダー',
		loading: '読み込み中...',
		my_bet: '私のベット'
	}
};